import { API_URL_AUTH, API_URL_STORE } from "./urls"

const login = async (credentials) =>
  window.axios
    .post(API_URL_AUTH + "login", {
      version: "",
      entityAction: {},
      entityInfo: {
        ...credentials,
        accessToken: "",
        appPackage: "",
        appVersion: "",
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        const user = {
          ...data.responseEntity,
          userLogin: credentials.userLogin,
        }

        return user
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

const refreshJwt = async (expiredTokens, userLogin, refreshToken) => {
  if (window.MobileApp) {
    const credentialsData = window.MobileApp.getAuthData()
    const credentials = JSON.parse(credentialsData)

    return login(credentials)
  }

  return window.axios

    .post(
      API_URL_AUTH + "jwt/refresh",
      {
        version: "",
        entityAction: {},
        entityInfo: {
          ...expiredTokens,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      },
    )

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        const user = { ...data.responseEntity, userLogin }

        return user
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })
}

// GET request

const getUserDetailsApi = () =>
  window.axios

    .get(API_URL_STORE + "user-v1/current/v1/get")

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const userDeatils = data.createdEntity

        return userDeatils
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

export { login, refreshJwt, getUserDetailsApi }
